import { Doughnut } from 'vue-chartjs'
import {mapState} from "vuex";

export default {
    extends: Doughnut,
    mounted () {
        let datas = this.datas.transaction_by_means;
        let meansNames = [];
        let meansXCount = [];
        if(datas){
            for(const data of datas){
                meansNames.push(data.means_name)
                meansXCount.push(data.total_count)
            }
            
        }
        this.renderChart({
            labels: meansNames, //['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
            datasets: [
                {
                    backgroundColor: [
                        '#41B883',
                        '#E46651',
                        '#00D8FF',
                        '#DD1B16'
                    ],
                    data: meansXCount// [40, 20, 80, 10]
                }
            ]
        }, {responsive: true, maintainAspectRatio: false})
    },
    computed:{
        ...mapState('means_paiements/', ['means_paiements']),
        ...mapState('dashboard',['datas'])
    }
}
